<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'un Promoteur</span>
    </sticky>
    <div class="columns is-gapless has-bg-light is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-10 is-8-widescreen">
        <div class="has-bg-white is-border">
          <promoteur-form @submit="submit" :loading="loading"></promoteur-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PromoteurForm from '@/components/promoteur/PromoteurForm'

  export default {
    name: 'PromoteurCreate',
    data () {
      return {
        loading: false
      }
    },
    components: {
      PromoteurForm
    },
    methods: {
      submit (promoteur) {
        this.loading = true
        this.$api.promoteurService.post(promoteur).then(r => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le promoteur a bien été ajouté'
          })
          this.$router.push({name: 'PromoteurVue', params: {id: r.data.pk}})
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du promoteur.'
          })
        })
      }
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurCreate.vue